import setCurrentPage from "src/Utils/setCurrentPage";
import Image from "../../Common/Image";

const LIST_DATA_INTRO_TEMPLATE = [
  {
    icon: "phone",
    iconColor: "white",
    text: "<b>Call Elimination</b>\nEliminate Customer’s need to reach care centers",
    listItemCustomStyle: { width: "250px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "personPhone",
    iconColor: "white",
    text: "<b>Digital Containment</b>\nShift customers to the most optimum channel & agent",
    listItemCustomStyle: { width: "250px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "settings",
    iconColor: "white",
    text: "<b>Effective Operations</b>\nProvide great experiences and resolutions along with automation and improvements",
    listItemCustomStyle: { width: "250px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_INTRO_CORTEX = {
  styleLeftPanel: {
    paddingRight: 0,
    paddingTop: "54px",
    paddingBottom: "51px",
    borderRadius: "0px 15px 15px 0px",
    minWidth: "1380px",
    minHeight: "845px",
  },
  title: "Customer Services Transformation",
  text: "Infosys Cortex, an Artificial Intelligence (AI)-driven customer engagement\nplatform, transforms contact center operations through purposeful\ncommunication and smart decision-making capabilities. It extracts and\nconverts micro data from customer interactions into insights for real-time\naction.",
  listData: LIST_DATA_INTRO_TEMPLATE,
  next: {
    label: "FIND OUT HOW",
    onClick: () => {
      window.open("https://cortex-demo1.idemo-ppc.com/#/ai-as-customer", "_self");
    },
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("INTRO_0"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "CORTEX/bg.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "AI_TWIN/InfosysTopazLogo.png",
  rightSideComponent: (
    <div style={{ position: "absolute", bottom: "0", right: "0" }}>
      <Image imagePath="CORTEX/RightSideImage.png" />
    </div>
  ),
};
